import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  padLeft?: number
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: ({ padLeft }) => `${padLeft ?? 0}px`,
    height: '100%',
    maxHeight: '40px',
    transition: 'all 200ms ease-in-out'
  },

  name: {
    fontSize: '2vw',
    color: theme.palette.textAlt,
    opacity: '0.1',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}))

export default useStyles
